import { useEffect, useReducer, useCallback } from "react";
import { clearAllAuthKeys } from "../api";

// Zentraler Auth-Zugriff — ersetzt verstreute localStorage.getItem-Aufrufe.
// Liest live aus localStorage (immer aktuell, kein Provider nötig) und
// re-rendert bei Änderungen: "storage" (andere Tabs) + "aof-auth-changed"
// (eigener Tab, dispatcht von api.js setToken/clearToken/clearAllAuthKeys
// und UserLogin).
export default function useAuth() {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    window.addEventListener("storage", forceUpdate);
    window.addEventListener("aof-auth-changed", forceUpdate);
    return () => {
      window.removeEventListener("storage", forceUpdate);
      window.removeEventListener("aof-auth-changed", forceUpdate);
    };
  }, []);

  const logout = useCallback(() => {
    clearAllAuthKeys();
  }, []);

  const token = localStorage.getItem("token");
  return {
    token,
    userId: localStorage.getItem("userId"),
    username: localStorage.getItem("username"),
    email: localStorage.getItem("email"),
    isModerator: localStorage.getItem("isModerator") === "true",
    waveAccess: localStorage.getItem("waveAccess") === "true",
    isAuthenticated: !!token,
    logout,
  };
}
